import {ApiError} from '../client';

type FastApiValidationError = {msg: string};

function formatApiBodyDetail(body: unknown): string | undefined {
    if (!body || typeof body !== 'object') {
        return undefined;
    }
    const detail = (body as {detail?: unknown}).detail;
    if (typeof detail === 'string') {
        return detail;
    }
    if (Array.isArray(detail)) {
        return detail
            .map((entry) => {
                if (typeof entry === 'string') {
                    return entry;
                }
                if (entry && typeof entry === 'object' && 'msg' in entry) {
                    return (entry as FastApiValidationError).msg;
                }
                return undefined;
            })
            .filter((line): line is string => Boolean(line))
            .join(', ');
    }
    return undefined;
}

export function formatRequestError(err: unknown, fallback: string): string {
    if (err instanceof ApiError) {
        const detail = formatApiBodyDetail(err.body);
        if (detail) {
            return detail;
        }
    }
    if (err instanceof Error && err.message.trim()) {
        return err.message;
    }
    return fallback;
}
